import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { comparisonRows, planIncludes } from '../../data/landing';
export function PlanMaestro() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-202" data-mp="ewrjl5tqrimd">
      <div className="mx-auto max-w-5xl" data-id="element-203" data-mp="jut0pl7lx7v7">
        <SectionHeading title="¿Qué agrega el Plan Maestro (30 días)?" data-id="element-204" data-mp="jvungmxzjisr" />

        <div className="mt-12 overflow-hidden rounded-3xl border border-line bg-white" data-id="element-205" data-mp="17knf477kr4hk">
          <div className="hidden grid-cols-[1.1fr_1fr_1fr] border-b border-line text-sm font-black uppercase tracking-wider md:grid" data-id="element-206" data-mp="1cjgu642if3ju">
            <div className="px-6 py-4 text-muted" data-id="element-207" data-mp="xl6a7s05cumn">Situación</div>
            <div className="flex items-center gap-2 bg-danger-soft px-6 py-4 text-danger" data-id="element-208" data-mp="12l0zjr49xc5l">
              <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-209" data-mp="3icf4jteomng2" /> Sin Plan Maestro
            </div>
            <div className="flex items-center gap-2 bg-brand px-6 py-4 text-white" data-id="element-210" data-mp="3nb9ynri3nyfh">
              <CheckIcon className="h-4 w-4 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-211" data-mp="1tdefq4jtcrji" /> Con Plan Maestro
            </div>
          </div>
          <ul className="divide-y divide-line" data-id="element-212" data-mp="1ofcvvhekco6z">
            {comparisonRows.map(r => <li key={r.situation} className="grid md:grid-cols-[1.1fr_1fr_1fr]" data-id="element-213" data-mp="22ecikjiimt0i">
                <div className="px-6 pb-2 pt-5 text-base font-extrabold text-brand md:py-5" data-id="element-214" data-mp="1xehvys5rwpl9">
                  {r.situation}
                </div>
                <div className="flex items-start gap-2 px-6 py-2 text-sm text-charcoal md:bg-danger-soft/50 md:py-5 md:text-base" data-id="element-215" data-mp="2cafmnuwxh1q3">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger md:hidden" strokeWidth={3} aria-hidden="true" data-id="element-216" data-mp="2l4kiksqx53ch" />
                  <span className="sr-only" data-id="element-217" data-mp="2h2gw792poecf">Sin Plan Maestro: </span>
                  {r.without}
                </div>
                <div className="flex items-start gap-2 bg-brand-soft px-6 pb-5 pt-2 text-sm font-semibold text-brand md:py-5 md:text-base" data-id="element-218" data-mp="2v3t9tdueg3v5">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand md:hidden" strokeWidth={3} aria-hidden="true" data-id="element-219" data-mp="2q1kh8ilfv3tk" />
                  <span className="sr-only" data-id="element-220" data-mp="1rrktzcnbgq78">Con Plan Maestro: </span>
                  {r.with}
                </div>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 rounded-3xl bg-brand-soft p-7 md:p-10" data-id="element-221" data-mp="1wp47ubg3r0yn">
          <h3 className="text-xl font-extrabold text-brand" data-id="element-222" data-mp="21j8gr08xhj2d">El Plan Maestro incluye:</h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-223" data-mp="26fyu3ftcm0k3">
            {planIncludes.map(item => <li key={item} className="flex items-start gap-3 text-base text-charcoal" data-id="element-224" data-mp="2beig1g7xzccg">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-225" data-mp="2fihxc111qf6v">
                  <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-226" data-mp="2kf8deocupasa" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}